import { render, staticRenderFns } from "./WannasornIdCardTab.vue?vue&type=template&id=273434ee"
import script from "./WannasornIdCardTab.vue?vue&type=script&lang=js"
export * from "./WannasornIdCardTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports